import { Router } from '@angular/router';

type MfeRoutingEventType = <T>(router: Router) => (event: CustomEvent<T>) => void;

export const routingEvent: MfeRoutingEventType = (router: Router) => (event: CustomEvent) => {
  const { orchestratorRoute, queryParams } = event.detail;

  router.navigate([orchestratorRoute], { queryParams });
};
